export default __webpack_public_path__ + "static/media/small.35ff214c.jpg";